"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createEntityMock = createEntityMock;
exports.resolveItem = resolveItem;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _mersenne = _interopRequireDefault(require("mersenne"));

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context11; _forEachInstanceProperty2(_context11 = ownKeys(Object(source), true)).call(_context11, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context12; _forEachInstanceProperty2(_context12 = ownKeys(Object(source))).call(_context12, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

_mersenne.default.seed(101);

function timeout(_x) {
  return _timeout.apply(this, arguments);
}

function _timeout() {
  _timeout = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(ms) {
    return _regenerator.default.wrap(function _callee7$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", new _promise.default(function (resolve) {
              return (0, _setTimeout2.default)(resolve, ms);
            }));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee7);
  }));
  return _timeout.apply(this, arguments);
}

function random(min, max) {
  var r = _mersenne.default.rand(max - min + 1);

  var result = r + min - 1;
  return result < min ? min : result > max ? max : result;
}

function createEntityMock(_ref) {
  var _context;

  var fields = _ref.fields,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 10 : _ref$rows,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$itemsPerPage = _ref.itemsPerPage,
      itemsPerPage = _ref$itemsPerPage === void 0 ? 20 : _ref$itemsPerPage,
      _ref$throwErrorOnFetc = _ref.throwErrorOnFetch,
      throwErrorOnFetch = _ref$throwErrorOnFetc === void 0 ? false : _ref$throwErrorOnFetc;

  if (process.env.NODE_ENV === 'production') {
    console.error('You REALLY should not use mocks in production!');
  }

  var data = (0, _map.default)(_context = (0, _from.default)(new Array(rows))).call(_context, function (_, i) {
    var _context2;

    return _objectSpread({
      id: "".concat(i + 1)
    }, (0, _reduce.default)(_context2 = (0, _keys.default)(fields)).call(_context2, function (all, field) {
      return _objectSpread(_objectSpread({}, all), {}, (0, _defineProperty2.default)({}, field, fields[field]({
        index: i,
        id: "".concat(i + 1)
      })));
    }, {}));
  });
  return {
    api: {
      fetchList: function () {
        var _fetchList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(type) {
          var _process, _process$env;

          var args,
              currentPage,
              perPage,
              totalPages,
              page,
              _args = arguments;
          return _regenerator.default.wrap(function _callee$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  args = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                  currentPage = args.page || 1;
                  perPage = args.per_page || itemsPerPage;
                  totalPages = Math.ceil(data.length / perPage);
                  page = (0, _slice.default)(data).call(data, (currentPage - 1) * perPage, (currentPage - 1) * perPage + perPage);
                  page = (0, _map.default)(page).call(page, function (item) {
                    return resolveItem(item, args);
                  });

                  if (((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'dev') {
                    // eslint-disable-next-line
                    console.log('📦 fetchList', type, args, page);
                  }

                  _context3.next = 9;
                  return timeout(delay);

                case 9:
                  if (!throwErrorOnFetch) {
                    _context3.next = 11;
                    break;
                  }

                  throw new Error('This error was thrown on purpose');

                case 11:
                  return _context3.abrupt("return", {
                    data: page,
                    pagination: {
                      endReached: currentPage === totalPages,
                      // eslint-disable-next-line
                      per_page: perPage,
                      // eslint-disable-next-line
                      current_page: currentPage,
                      // eslint-disable-next-line
                      total_pages: totalPages,
                      total: data.length,
                      links: {
                        next: currentPage !== totalPages
                      }
                    }
                  });

                case 12:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee);
        }));

        function fetchList(_x2) {
          return _fetchList.apply(this, arguments);
        }

        return fetchList;
      }(),
      fetchItem: function () {
        var _fetchItem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(type, args, id) {
          var _process2, _process2$env;

          var item;
          return _regenerator.default.wrap(function _callee2$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  item = resolveItem((0, _find.default)(data).call(data, function (item) {
                    return item.id.toString() === id.toString();
                  }), args);

                  if (((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.NODE_ENV) === 'dev') {
                    // eslint-disable-next-line
                    console.log('📦 fetchItem', type, args, id, {
                      item: item
                    });
                  }

                  _context4.next = 4;
                  return timeout(delay);

                case 4:
                  if (!throwErrorOnFetch) {
                    _context4.next = 6;
                    break;
                  }

                  throw new Error('This error was thrown on purpose');

                case 6:
                  if (item !== null && item !== void 0 && item.id) {
                    _context4.next = 8;
                    break;
                  }

                  throw new Error('Not found');

                case 8:
                  return _context4.abrupt("return", {
                    data: item
                  });

                case 9:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee2);
        }));

        function fetchItem(_x3, _x4, _x5) {
          return _fetchItem.apply(this, arguments);
        }

        return fetchItem;
      }(),
      createItem: function () {
        var _createItem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(type, args) {
          return _regenerator.default.wrap(function _callee3$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return timeout(delay);

                case 2:
                  return _context5.abrupt("return", {
                    data: args
                  });

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee3);
        }));

        function createItem(_x6, _x7) {
          return _createItem.apply(this, arguments);
        }

        return createItem;
      }(),
      updateItem: function () {
        var _updateItem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(type, args, id) {
          var _process3, _process3$env;

          var item;
          return _regenerator.default.wrap(function _callee4$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  item = resolveItem((0, _find.default)(data).call(data, function (item) {
                    return item.id.toString() === id.toString();
                  }), args);

                  if (((_process3 = process) === null || _process3 === void 0 ? void 0 : (_process3$env = _process3.env) === null || _process3$env === void 0 ? void 0 : _process3$env.NODE_ENV) === 'dev') {
                    // eslint-disable-next-line
                    console.log('📦 updateItem', type, args, id, {
                      item: item
                    });
                  }

                  item = (0, _lodash.merge)(item, args);
                  _context6.next = 5;
                  return timeout(delay);

                case 5:
                  return _context6.abrupt("return", {
                    data: item
                  });

                case 6:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee4);
        }));

        function updateItem(_x8, _x9, _x10) {
          return _updateItem.apply(this, arguments);
        }

        return updateItem;
      }(),
      trashItem: function () {
        var _trashItem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
          return _regenerator.default.wrap(function _callee5$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return timeout(delay);

                case 2:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee5);
        }));

        function trashItem() {
          return _trashItem.apply(this, arguments);
        }

        return trashItem;
      }(),
      bulkTrashItems: function () {
        var _bulkTrashItems = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
          return _regenerator.default.wrap(function _callee6$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return timeout(delay);

                case 2:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee6);
        }));

        function bulkTrashItems() {
          return _bulkTrashItems.apply(this, arguments);
        }

        return bulkTrashItems;
      }()
    },
    data: data,

    /**
     * @param mock // mock instance from `createEntityMock`
     * @property {Object} fetchArgs
     * @property {string} fetchArgs.field field on the model to create a relationship on
     * @property {number} fetchArgs.min minimum number of related entities to create.
     * @property {number} fetchArgs.max maximum number of related entities to create.
     * @property {string} fetchArgs.include path to the related entity e.g. person.relatedPerson
     */
    addRelation: function addRelation(mock, _ref2) {
      var field = _ref2.field,
          _ref2$min = _ref2.min,
          min = _ref2$min === void 0 ? 1 : _ref2$min,
          _ref2$max = _ref2.max,
          max = _ref2$max === void 0 ? 1 : _ref2$max,
          _ref2$include = _ref2.include,
          include = _ref2$include === void 0 ? '' : _ref2$include;

      // Checks the request arguments against the include string of the related entity to see if it is used.
      // This ensures that related entities are only requested when actually used.
      var shouldInclude = function shouldInclude(fetchArgs) {
        var _fetchArgs$include, _fetchArgs$include$sp, _fetchArgs$include$sp2;

        return !include || !!(fetchArgs !== null && fetchArgs !== void 0 && (_fetchArgs$include = fetchArgs.include) !== null && _fetchArgs$include !== void 0 && (_fetchArgs$include$sp = _fetchArgs$include.split) !== null && _fetchArgs$include$sp !== void 0 && (_fetchArgs$include$sp2 = _fetchArgs$include$sp.call(_fetchArgs$include, ',')) !== null && _fetchArgs$include$sp2 !== void 0 && (0, _find.default)(_fetchArgs$include$sp2).call(_fetchArgs$include$sp2, function (x) {
          return x === include || (0, _includes.default)(x).call(x, include);
        }));
      };
      /**
       * If the mock is provided in an array, it indicates a 1:many relationship.
       * If there are many related entities, get data for a random number of them between min-max,
       * otherwise, just resolve data for the one related entity.
       */
      // Determine how many relationships to create between specified min & max.


      var numRelatedEntities = random(min, max); // If this is a 1:many relationship, return mock items for each relationship

      var mockItem = function mockItem(randomItem) {
        return (0, _isArray.default)(mock) ? {
          items: numRelatedEntities > 0 ? (0, _lodash.times)(numRelatedEntities + 1, function (idx) {
            return mock[0].data[randomItem + idx];
          }) // Grab a mock item for each related entity.
          : [] // no related entities required.

        } : resolveItem(mock.data[randomItem + numRelatedEntities]);
      }; // Mutates data object on purpose!


      (0, _forEach.default)(data).call(data, function (item) {
        // Get a determitinistic (but "random") element from the mock data.
        var randomItemIdx = (0, _isArray.default)(mock) ? random(0, mock[0].data.length - numRelatedEntities) // 1:many (if there are many mocks, is this right? should the index here not also be random? - JG)
        : random(0, mock.data.length - numRelatedEntities); // 1:1

        item[field] = function (_ref3) {
          var args = _ref3.args;
          return shouldInclude(args) ? mockItem(randomItemIdx) : undefined;
        };
      });
    }
  };
}
/**
 * Resolves a field on an entity to return its value, by recursively
 * stepping through a collection object|array and either returning a value or
 * running a function to return the value.
 *
 * @param {Object} item related entity
 * @param {*} fetchArgs arguments used to fetch entity data
 */


function resolveItem(item, fetchArgs) {
  var _context9;

  if (!item) {
    return;
  } // If the value is a string, return early in order to avoid it being broken into characters by Object.keys.


  if ((0, _lodash.isString)(item)) {
    return item;
  } // Recursive through a field and all its children fields and resolve a value. This is achieved
  // by invoking a function and returning its result, returning a value, or recursing.


  return (0, _reduce.default)(_context9 = (0, _keys.default)(item)).call(_context9, function (all, key) {
    // If the value is a function, invoke it and return its result, if it's a collection object|array,
    // then recursively resolve its children too. Otherwise just return a value
    var val = (0, _lodash.cond)([[_lodash.isFunction, function (fn) {
      return resolveItem(fn({
        args: fetchArgs
      }), fetchArgs);
    }], [_lodash.isArray, function (arr) {
      return (0, _map.default)(arr).call(arr, function (i) {
        return resolveItem(i, fetchArgs);
      });
    }], [_lodash.isObject, function (obj) {
      return resolveItem(obj, fetchArgs);
    }], [function () {
      return true;
    }, _lodash.identity]])(item[key]);

    if (typeof val !== 'undefined') {
      all[key] = val;
    }

    return all;
  }, {});
}